<template></template>
<script setup>
import { useEventListener } from '@vueuse/core';

const props = defineProps({
    isDirty: {
        required: true,
        type: Boolean,
    },
});
let beforeUnloadListener = (evt) => {
    if (props.isDirty) {
        evt.preventDefault();
        evt.returnValue = '---'; //Browsers won't display messages in this scenario anymore
    }
};
useEventListener(window, 'beforeunload', beforeUnloadListener, { capture: true });
</script>
<script>
export default {
    name: 'UnsavedChangesFormWarning',
};
</script>
